import { render, staticRenderFns } from "./table-controller.vue?vue&type=template&id=724876aa"
import script from "./table-controller.vue?vue&type=script&lang=js"
export * from "./table-controller.vue?vue&type=script&lang=js"
import style0 from "./table-controller.vue?vue&type=style&index=0&id=724876aa&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports